enum Route {
  HomePage = '/',
  BookingTerms = '/booking-terms',
  TermsOfUse = '/terms-of-use',
  PrivacyPolicy = '/privacy-policy',
  QuotesRequest = '/quotes-request',
  Move = '/move/:moveId',
  EditMove = '/move/:moveId/edit',
  PayBalance = '/move/:moveId/pb',
  Rating = '/move/:moveId/rating',
  StripeLandingPage = '/move/:moveId/stripe',
  PaymentReceivedPage = '/move/:moveId/payment-success',
  MoveReminder = '/move-reminder',
}

export default Route
